$(document).ready(function() {
	$('#scroll-to-top').click(function() {
	  $('html, body').animate({ scrollTop: 0 }, 500);
	  return false;
	});

	$(window).scroll(function(){
		animateShow();
	});
});


function animateShow () {
	$('.js-scroll').each(function(){
  		var top = this.getBoundingClientRect().top;
  		if (top <= 700) {
	   		$(this).find('.show-on-desk').addClass('is-active');
		}
	  	if (top <= 500) {
		    $(this).find('.show-on-mobi').addClass('is-active');
	  	}
	  	if (top <= 400) {
		    $(this).find('.page-dripbag-content').addClass('is-active');
		    $(this).removeClass('js-scroll');
	  	}
	});
}